export default {
      id: "Icon--contact-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--contact",
      toString: function () {
        return this.url;
      }
    }